
import Vue from 'vue'
import ProjectMixin from '@/_mixins/project'

import { deleteRequest } from '@/plugins/api-axios'

import InlineUser from '@/views/User/components/inlineUser/inlineUser.vue'
import FormResponseViewerDialog from '@/views/Project/PSI/dialogs/formResponseViewer.vue'
import ConfirmationDialog from '@/views/Project/Form/dialogs/confirmation.vue'

const CompletionCard = Vue.extend({
    mixins: [ProjectMixin],
    components: { InlineUser },
    props: {
        completion: {
            type: Object,
            required: true,
        },
        response: {
            type: Object,
        },
    },
    methods: {
        async viewSubmission(resourceFormResponse: any) {
            await this.openDialog(FormResponseViewerDialog, {
                resourceFormResponse,
                psi: resourceFormResponse.psi.data,
            })
        },

        async deleteCompletion() {
            let ok = await this.openDialog(ConfirmationDialog, {
                message: this.$t('psi_fe["completion.text_deleteCompletionConfirmation"]', {
                    title: this.response.revision.data.data.title[this.response.languageId],
                }),
                title: this.$t('psi_fe["completion.heading_deleteCompletion"]'),
            })

            if (!ok) return

            await deleteRequest(
                this.getURL({
                    path: `psiCompletions/${this.completion.id}`,
                    base: this.psiBaseUrl,
                }),
                this.getRequestHeaders('DELETE')
            )

            this.$emit('delete', this.completion)
        },
    },
})

export default CompletionCard
